import * as Select from '@radix-ui/react-select';
import { Fragment } from 'react';

import { DropdownItem } from '~/chords/DropdownSingleSelect/components/DropdownItem';
import type {
  InternalDropdownOption,
  InternalDropdownOptions,
  OptionTemplateComponent,
  RadixUiProps,
} from '~/chords/DropdownSingleSelect/types';

interface DropdownItemsProps extends RadixUiProps {
  options: InternalDropdownOptions;
  searchQuery?: string;
  selectedOption?: InternalDropdownOption;
  onSelectOption?: (option: InternalDropdownOption) => void;
  showCheckIcon?: boolean;
  OptionTemplate?: OptionTemplateComponent;
}

export function DropdownItems({
  options,
  searchQuery,
  selectedOption,
  onSelectOption,
  showCheckIcon,
  OptionTemplate,
  radix = {},
}: DropdownItemsProps) {
  return (
    <>
      {options.map((group, index) => (
        <Fragment key={index}>
          {group.length && index && !searchQuery ? (
            <Select.Separator
              {...radix.selectSeparator}
              className="mx-md my-xs h-px bg-emphasis-subtle"
            />
          ) : null}
          <Select.Group {...radix.selectGroup}>
            {group.map((option) => (
              <DropdownItem
                key={option.value}
                option={option}
                selectedOption={selectedOption}
                onSelectOption={onSelectOption}
                showCheckIcon={showCheckIcon}
                searchQuery={searchQuery}
                OptionTemplate={OptionTemplate}
                radix={radix}
              />
            ))}
          </Select.Group>
        </Fragment>
      ))}
    </>
  );
}

DropdownItems.displayName = 'DropdownItems';
